import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  examFilter: {
    database: [],
    university: [],
    year: [],
    unite: [],
    shift: [],
    subject: [],
    chapter: [],
    topic: [],
  },
  ableToExam: false,
  examStartTime: undefined,
  examSubmitted: false,
  questionsForExam: [],
  fetchedQuestions: [],
  sharedExamObj: {},
  question_added: false,
  allExamData:
    JSON.parse(JSON.stringify(JSON.parse(localStorage.getItem("exams")))) || [],
  saveUpdateState: false,

  // new variables
  singleQuestion: {
    json_question_paper: [],
  },
  submittedExamData: {},
};

const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    setExamFilter: (state, action) => {
      state.examFilter = {
        ...state.examFilter, // Retain existing data
        ...action.payload, // Merge new data
      };
    },

    setQuestionsForExam: (state, action) => {
      const { question, examId } = action.payload;

      if (examData?.json_question_paper?.length <= 0) {
        // Check if the exam already exists in questionsForExam
        const existingExam = state.questionsForExam.find(
          (exam) => exam?.id === examId
        );

        if (!existingExam) {
          // Add new exam if it doesn't exist in questionsForExam
          state.questionsForExam.push({
            ...examData,
            json_question_paper: [question],
          });
        } else {
          // Deep copy the existing exam to avoid modifying the proxy directly
          const tempExam = JSON.parse(JSON.stringify(existingExam));

          // Check if the question already exists in the json_question_paper
          const questionExists = tempExam.json_question_paper.some(
            (q) => q.pk === question.pk
          );

          if (questionExists) {
            // Remove the question if it exists
            tempExam.json_question_paper = tempExam.json_question_paper.filter(
              (q) => q.pk !== question.pk
            );
          } else {
            // Add the question if it doesn't exist
            tempExam.json_question_paper.push(question);
          }

          // Update the state with the modified exam
          state.questionsForExam = state.questionsForExam.map((exam) =>
            exam.id === examId ? tempExam : exam
          );
        }
      } else {
        const existingExam = state.questionsForExam.find(
          (exam) => exam?.id === examId
        );

        let tempExam = JSON.parse(JSON.stringify(existingExam));

        // Check if the question already exists in the json_question_paper
        const questionExists = tempExam.json_question_paper.some(
          (q) => q.pk === question.pk
        );

        if (questionExists) {
          // Remove the question if it exists
          tempExam.json_question_paper = tempExam.json_question_paper.filter(
            (q) => q.pk !== question.pk
          );
        } else {
          // Add the question if it doesn't exist
          tempExam.json_question_paper.push(question);
        }
        // Update the state with the modified exam
        state.questionsForExam = state.questionsForExam.map((exam) =>
          exam.id === examId ? tempExam : exam
        );
      }

      localStorage.setItem(
        "updated-question",
        JSON.stringify(state.questionsForExam)
      );
    },

    examSaveUpdateCheckState: (state, action) => {
      state.saveUpdateState = action.payload;
    },
    setFetchedQuestions: (state, action) => {
      state.fetchedQuestions = action.payload;
    },
    setAllExamData: (state, action) => {
      state.allExamData = action.payload;
      localStorage.setItem("exams", JSON.stringify(state.allExamData));
    },
    setExamInData: (state, action) => {
      const existingIndex = state.questionsForExam.findIndex(
        (question) => question.id === action.payload.id
      );

      if (existingIndex !== -1) {
        // Replace the existing object with the new one
        state.questionsForExam[existingIndex] = action.payload;
      } else {
        // Add the new object to the array
        state.questionsForExam.push(action.payload);
      }
    },
    setAbleToExam: (state, action) => {
      state.ableToExam = !state.ableToExam;
      state.examStartTime = new Date().getTime();
    },

    // add new logic to exam
    setSingleExam: (state, action) => {
      state.singleQuestion = action.payload;
    },
    setQuestionsFromDatabase: (state, action) => {
      const { question } = action.payload;

      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));

      const existingQuestion = specificExam?.json_question_paper?.find(
        (ques) => ques.pk === question.pk
      );

      if (existingQuestion === undefined) {
        specificExam?.json_question_paper.push(question);
      } else {
        specificExam.json_question_paper =
          specificExam.json_question_paper.filter(
            (ques) => ques.pk !== question.pk
          );
      }

      state.singleQuestion = specificExam;
    },
    setDeleteQuestionFromExam: (state, action) => {
      const { questionPosition } = action.payload;
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));

      specificExam.json_question_paper.splice(questionPosition, 1);

      state.singleQuestion = specificExam;
    },

    setUpdateQuestionForExam: (state, action) => {
      const { questionPosition, question } = action.payload;
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));

      specificExam.json_question_paper[questionPosition] = question;

      console.log(specificExam);

      // state.singleQuestion = specificExam;
    },

    setUpdateQuestionFieldOfExam: (state, action) => {
      const { questionPosition, field, data } = action.payload;
      // Create a deep copy of the state to avoid mutating the original state
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));
      specificExam.json_question_paper[questionPosition][field] = data;

      // Set the updated data to state
      state.singleQuestion = specificExam;
    },
    setMcqInExamWithQuestionFixed: (state, action) => {
      const { data, questionPosition, optionIndex } = action.payload;
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));

      if (
        specificExam &&
        specificExam.json_question_paper &&
        specificExam.json_question_paper[questionPosition] &&
        specificExam.json_question_paper[questionPosition].options &&
        specificExam.json_question_paper[questionPosition].options[optionIndex]
      ) {
        specificExam.json_question_paper[questionPosition].options[
          optionIndex
        ].option = data;
      }

      state.singleQuestion = specificExam;
    },
    setAddNewMcqInExamWithQuestionFixed: (state, action) => {
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion)); // Deep copy for immutability
      const { data, questionPosition } = action.payload;

      // Ensure the question and options exist
      if (
        specificExam?.json_question_paper &&
        specificExam.json_question_paper[questionPosition] &&
        Array.isArray(
          specificExam.json_question_paper[questionPosition].options
        )
      ) {
        specificExam.json_question_paper[questionPosition].options.push(data); // Add the new MCQ
      } else {
        console.error(
          "Invalid structure or question not found at position:",
          questionPosition
        );
      }

      // Update the state
      state.singleQuestion = specificExam;
    },
    setRemoveMcqInExamWithQuestionFixed: (state, action) => {
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));
      const { questionPosition, mcqPosition } = action.payload;
      specificExam.json_question_paper[questionPosition].options.splice(
        mcqPosition,
        1
      );

      state.singleQuestion = specificExam;
    },

    setAddNewDummyQuestion: (state, action) => {
      let { demo_question } = action.payload;
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));

      specificExam?.json_question_paper?.push(demo_question);

      state.singleQuestion = specificExam;
      state.question_added = true;
    },
    setQuestionAddedFalse: (state, action) => {
      state.question_added = false;
    },
    setMcqInExamSharedExam: (state, action) => {
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));

      specificExam.json_question_paper[
        action.payload.questionId
      ].index_selected_by_student = action.payload.indexNumber;

      state.singleQuestion = specificExam;
    },
    setFinalExamDataAfterSubmit: (state, action) => {
      state.submittedExamData = action.payload;
    },
    setExamSubmitted: (state, action) => {
      state.examSubmitted = true;
    },
    setCorrectAnswerOnQuestion: (state, action) => {
      const { index: answerIndex, id: questionIndex } = action.payload;
      const specificExam = JSON.parse(JSON.stringify(state.singleQuestion));

      const updatedOptions = specificExam?.json_question_paper[
        questionIndex
      ]?.options?.map((value, index) => {
        if (index === answerIndex) {
          return { ...value, answer: true };
        } else {
          return { ...value, answer: false };
        }
      });

      specificExam.json_question_paper[questionIndex].options = updatedOptions;

      state.singleQuestion = specificExam;
    },
  },
});

export default examSlice;
export const {
  setExamFilter,
  setQuestionsForExam,
  setUpdateQuestionForExam,
  setAllExamData,
  setDeleteQuestionFromExam,
  setFetchedQuestions,
  setExamInData,
  examSaveUpdateCheckState,
  setAddNewDummyQuestion,
  setMcqInExamSharedExam,
  setAbleToExam,
  setSingleExam,
  setQuestionsFromDatabase,
  setUpdateQuestionFieldOfExam,
  setMcqInExamWithQuestionFixed,
  setAddNewMcqInExamWithQuestionFixed,
  setRemoveMcqInExamWithQuestionFixed,
  setQuestionAddedFalse,
  setExamSubmitted,
  setFinalExamDataAfterSubmit,
  setCorrectAnswerOnQuestion,
} = examSlice.actions;
